<template>
  <div
    class="ticket-container print-no-hidden-all"
    :style="{ fontFamily: `${$store.fontFamilyDefault}, sans-serif` }"
  >
    <svg
      class="ticket-fence print-hidden"
      width="320"
      height="16"
      viewBox="0 0 320 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8C20.4183 8 24 4.41828 24 0H32C32 4.41828 35.5817 8 40 8C44.4183 8 48 4.41828 48 0H56C56 4.41828 59.5817 8 64 8C68.4183 8 72 4.41828 72 0H80C80 4.41828 83.5817 8 88 8C92.4183 8 96 4.41828 96 0H104C104 4.41828 107.582 8 112 8C116.418 8 120 4.41828 120 0H128C128 4.41828 131.582 8 136 8C140.418 8 144 4.41828 144 0H152C152 4.41828 155.582 8 160 8C164.418 8 168 4.41828 168 0H176C176 4.41828 179.582 8 184 8C188.418 8 192 4.41828 192 0H200C200 4.41828 203.582 8 208 8C212.418 8 216 4.41828 216 0H224C224 4.41828 227.582 8 232 8C236.418 8 240 4.41828 240 0H248C248 4.41828 251.582 8 256 8C260.418 8 264 4.41828 264 0H272C272 4.41828 275.582 8 280 8C284.418 8 288 4.41828 288 0H296C296 4.41828 299.582 8 304 8C308.418 8 312 4.41828 312 0H320V16H0V0H8C8 4.41828 11.5817 8 16 8Z"
        fill="white"
      />
    </svg>

    <div class="ticket-wrapper">
      <img
        v-if="showCompanyLogo"
        :src="ticketSettings.ticket_logo.file_url"
        class="ticket-logo"
        alt="Company logo"
        @load="ticketLogoLoaded()"
      />
      <div class="ticket-id">{{ ticket.prefix }}{{ ticket.number }}</div>
      <div
        v-if="
          ticketSettings.use_service_name &&
          ticket.service.name[currentLanguageTag]
        "
        class="ticket-service"
      >
        {{ ticket.service.name[currentLanguageTag] }}
      </div>
      <div v-if="ticket.name && ticket.surname" class="ticket-service">
        {{ ticket.name }} {{ ticket.surname }}
      </div>
      <div v-if="ticket.booking_time" class="ticket-service ticket-time flex">
        <p class="ri-notification-3-line"></p>
        <span class="ticket-time__value">{{ ticket.booking_time }}</span>
      </div>
      <!-- <div v-if="ticket.booking_time" class="ticket-service ticket-time flex">
        <i class="ri-notification-3-line"></i>
        <span class="ticket-time__value">{{ ticket.booking_time }}</span>
      </div> -->
      <div
        v-if="
          ticketSettings.use_service_definition &&
          ticket.service.print_text[currentLanguageTag]
        "
        class="ticket-service-desc"
      >
        {{ ticket.service.print_text[currentLanguageTag] }}
      </div>

      <div
        v-if="ticketSettings.use_info_about_office && officeDescription"
        class="ticket-office-info"
      >
        {{ officeDescription }}
      </div>
      <div class="hr" />
      <div
        v-if="ticketSettings.use_slogan && firmStyles.slogan"
        class="ticket-slogan"
      >
        {{ firmStyles.slogan }}
      </div>
      <div v-if="ticketSettings.use_slogan && firmStyles.slogan" class="hr" />
      <div
        v-if="ticketSettings.use_date_of_ticket_getting"
        class="ticket-getting-time"
      >
        {{ 'registrator_label_ticket_issued' | translate }} {{ ticketDate }}
      </div>
      <div
        v-if="ticketSettings.use_address_of_office && officeAddress"
        class="ticket-address"
      >
        {{ officeAddress }}
      </div>
      <div
        v-if="
          ticketSettings.use_telephone_of_office && $store.deviceStartData.phone
        "
        class="ticket-phone flex"
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M4.244 5.12133C4.86956 6.22032 5.77968 7.13044 6.87867 7.756L7.468 6.93067C7.56277 6.79796 7.7029 6.70459 7.86187 6.66822C8.02084 6.63186 8.18762 6.65502 8.33067 6.73333C9.27355 7.24862 10.3148 7.55852 11.386 7.64267C11.5532 7.65592 11.7092 7.73169 11.823 7.85488C11.9368 7.97807 12 8.13963 12 8.30733V11.282C12 11.4471 11.9388 11.6063 11.8282 11.7288C11.7177 11.8513 11.5655 11.9285 11.4013 11.9453C11.048 11.982 10.692 12 10.3333 12C4.62667 12 0 7.37333 0 1.66667C0 1.308 0.018 0.952 0.0546667 0.598667C0.0715031 0.434465 0.148656 0.282347 0.271193 0.171756C0.39373 0.0611648 0.552937 -3.55718e-05 0.718 1.55115e-08H3.69267C3.86037 -2.10123e-05 4.02193 0.0631677 4.14512 0.176967C4.26831 0.290767 4.34408 0.446816 4.35733 0.614C4.44148 1.68519 4.75138 2.72645 5.26667 3.66933C5.34498 3.81238 5.36814 3.97916 5.33178 4.13813C5.29541 4.2971 5.20204 4.43723 5.06933 4.532L4.244 5.12133ZM2.56267 4.68333L3.82933 3.77867C3.46986 3.00273 3.22357 2.17923 3.098 1.33333H1.34C1.336 1.444 1.334 1.55533 1.334 1.66667C1.33333 6.63733 5.36267 10.6667 10.3333 10.6667C10.4447 10.6667 10.556 10.6647 10.6667 10.66V8.902C9.82077 8.77643 8.99727 8.53014 8.22133 8.17067L7.31667 9.43733C6.95244 9.29581 6.59867 9.12873 6.258 8.93733L6.21933 8.91533C4.91172 8.17115 3.82885 7.08828 3.08467 5.78067L3.06267 5.742C2.87127 5.40133 2.70419 5.04756 2.56267 4.68333Z"
            fill="#1C1C1E"
          />
        </svg>
        <span class="ticket-phone__number">
          {{ $store.deviceStartData.phone }}
        </span>
      </div>
      <div
        v-if="
          ticketSettings.use_address_of_office ||
          ticketSettings.use_telephone_of_office ||
          ticketSettings.use_date_of_ticket_getting
        "
        class="hr"
      />
    </div>

    <svg
      class="ticket-fence print-hidden"
      width="320"
      height="16"
      viewBox="0 0 320 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8C20.4183 8 24 11.5817 24 16H32C32 11.5817 35.5817 8 40 8C44.4183 8 48 11.5817 48 16H56C56 11.5817 59.5817 8 64 8C68.4183 8 72 11.5817 72 16H80C80 11.5817 83.5817 8 88 8C92.4183 8 96 11.5817 96 16H104C104 11.5817 107.582 8 112 8C116.418 8 120 11.5817 120 16H128C128 11.5817 131.582 8 136 8C140.418 8 144 11.5817 144 16H152C152 11.5817 155.582 8 160 8C164.418 8 168 11.5817 168 16H176C176 11.5817 179.582 8 184 8C188.418 8 192 11.5817 192 16H200C200 11.5817 203.582 8 208 8C212.418 8 216 11.5817 216 16H224C224 11.5817 227.582 8 232 8C236.418 8 240 11.5817 240 16H248C248 11.5817 251.582 8 256 8C260.418 8 264 11.5817 264 16H272C272 11.5817 275.582 8 280 8C284.418 8 288 11.5817 288 16H296C296 11.5817 299.582 8 304 8C308.418 8 312 11.5817 312 16H320V0H0V16H8C8 11.5817 11.5817 8 16 8Z"
        fill="white"
      />
    </svg>
  </div>
</template>

<script>
import { getMonthsTranslation } from '@/helpers/utils';
import { printTicket } from '@/helpers/printTicket';

export default {
  name: 'Ticket',
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ticketSettings() {
      return this.$store.deviceStartData.unit_style;
    },
    currentLanguageTag() {
      return this.$store.currentLanguage.tag;
    },
    showCompanyLogo() {
      return (
        this.ticketSettings.use_company_logo &&
        this.ticketSettings.ticket_logo &&
        this.ticketSettings.ticket_logo.file_url
      );
    },
    firmStyles() {
      return this.$store.deviceStartData.firm_style;
    },
    officeSettings() {
      return this.$store.deviceStartData.office_settings;
    },
    officeDescription() {
      return this.officeSettings.registrator_text[this.currentLanguageTag];
    },
    ticketDate() {
      const date = new Date();

      const months = getMonthsTranslation(this.$store.activeLanguageConsts);
      const month = months[date.getMonth()];
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${date.getDate()} ${month} ${date.getFullYear()}, ${hours}:${minutes}`;
    },
    officeAddress() {
      return this.$store.deviceStartData.address[this.currentLanguageTag];
    },
    phone() {
      return this.$store.deviceStartData.phone;
    },
  },
  mounted() {
    if (!this.showCompanyLogo) this.sendTicket();
  },
  methods: {
    ticketLogoLoaded() {
      this.sendTicket();
    },
    sendTicket() {
      setTimeout(() => {
        this.$nextTick(() => {
          const canvas = document.createElement('canvas');
          printTicket(
            canvas,
            this.ticket,
            this.ticketSettings,
            this.firmStyles,
            this.officeSettings,
            this.officeAddress,
            this.phone,
            this.currentLanguageTag,
            this.ticketDate,
          ).then((data) => {
            this.$emit('ticketReady', data);
          });
        });
      }, 50);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../styles/variables.scss';

.ticket-container {
  width: 320px;
  max-height: 560px;
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: contain;
  box-shadow: 0px 60px 60px rgba(0, 0, 0, 0.051037);
  position: relative;
  word-break: break-word;
}

.ticket-wrapper {
  max-height: 100%;
  overflow: hidden;
  padding: 16px 10px 0 10px;
  background-color: #ffffff;

  & > *:not(:last-child):not(:first-child) {
    margin-top: 8px;
  }
}

.ticket-background {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.ticket {
  &-logo {
    max-width: 300px;
    height: 80px;
    background-repeat: no-repeat;
    background-position: center;
    object-fit: contain;
  }

  &-id {
    font-size: 42px;
    line-height: 51px;
  }

  &-service {
    font-size: 16px;
    word-break: break-word;
  }

  &-service-desc,
  &-office-info {
    line-height: 1.4;
  }

  &-service-desc,
  &-office-info,
  &-address {
    font: {
      size: 12px;
    }
  }

  &-address {
    line-height: 1.6;
  }

  &-estimated-time {
    font-size: 28px;
    height: 35px;

    &__wrapper {
      display: inline;
      position: relative;

      svg {
        position: absolute;
        top: 50%;
        left: -30px;
        transform: translateY(-50%);
      }
    }

    &__icon {
      font-size: 24px;
      margin-left: -23px;
    }
  }

  &-getting-time {
    font-size: 12px;
    line-height: 1.1;
  }

  &-phone,
  &-estimated-time,
  &-time {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  &-address {
    font-size: 12px;
  }

  &-phone {
    &__number {
      font-size: 16px;
      margin-left: 8px;
    }
  }

  &-time {
    i {
      font-size: 12px;
    }

    &__value {
      font-size: 16px;
      margin-left: 4px;
    }
  }

  &-phone__number,
  &-slogan,
  &-service,
  &-id {
    font-weight: 500;
  }

  &-slogan {
    font-size: 16px;
  }

  &-fence {
    min-height: 16px;
  }
}

.hr {
  display: inline !important;
  font-size: 12px;
  color: $color-label-secondary;
  pointer-events: none;
  white-space: nowrap;

  &:before {
    content: '………………………………………………………………………………';
  }
}
</style>
